import { mockUserObject } from "../services/MockUserObject";

//   Behavior controllable from .env.local
const delayChangePassword =             process.env.REACT_APP_CHANGE_PASSWORD_DELAY || 2000;
const delaySendVerificationCode =       process.env.REACT_APP_SEND_VERIFICATION_CODE_DELAY || 1000;
const delayGetVerificationOptions =     process.env.REACT_APP_GET_VERIFICATION_OPTIONS_DELAY || 1000;
const delayValidateVerificationCode =   process.env.REACT_APP_VALIDATE_VERIFICATION_CODE_DELAY || 1000;

const apiTestCase = { // Change booleans to construct desired test case
    successfulChangePassword:           (process.env.REACT_APP_SUCCESSSFUL_CHANGE_PASSWORD            !== "false"),
    successfulValidateToken:            (process.env.REACT_APP_SUCCESSSFUL_VALIDATE_TOKEN             !== "false"),
    successfulSendVerificationCode:     (process.env.REACT_APP_SUCCESSSFUL_SEND_VERIFICATION_CODE     !== "false"),
    successfulValidateVerificationCode: (process.env.REACT_APP_SUCCESSSFUL_VALIDATE_VERIFICATION_CODE !== "false"),
    successfulGetVerificationOptions:   (process.env.REACT_APP_SUCCESSSFUL_GET_VERIFICATION_OPTIONS   !== "false"),
    successfulGetVersion:               (process.env.REACT_APP_SUCCESSSFUL_GET_VERSION                !== "false"),
    successfulLookup:                   (process.env.REACT_APP_SUCCESSSFUL_LOOKUP                     !== "false"),
}


//   Reusable return data
const ok = { ok: true, status: "200" };
const notOk = { ok: false, status: "400", error: {status: "400", message: "not good!" }};

//    Select user for test
let selectedUser; 

export default class MockAPIService {
    static set_default_user() {
        selectedUser = mockUserObject.staff2;
    }

    static set_user(user) {
        selectedUser = user;
    }
    /* Real return values are always in the set: */
    // Success
    // return { ok: response.ok, ...data };
    // Failure
    // return { ok: false, error };
    // where error like { timestamp: "2020-04-22T18:46:40.333+0000", status: 400, error: "Bad Request", message: "Token not valid", path: "/api/token/validatecode" }


    static async change_password(netid, password, token) {
        /* Real parameter usage */
        // let body = {
        //     netid: netid,
        //     password: password,
        //     token: token
        // };

        await new Promise(r => setTimeout(r, delayChangePassword));
        
        return logAndPass(arguments, 
            apiTestCase.successfulChangePassword
            ? {...ok, user: selectedUser, token: "222222"}
            : notOk
        );
    }

    static async validate_token(token) {
        /* Real parameter usage */
        // let response = await fetch(`/api/token/validate?token=${token}`, config);

         // returns same object as validate_token
        return logAndPass(arguments, 
            apiTestCase.successfulValidateToken 
            ? {...ok, user: selectedUser, token: "111111"}
            : notOk
        );
    }


    static async send_verification_code(netid, verificationOptionId) {
        /* Real parameter usage */
        // let body = {
        //     netid: netid,
        //     verificationOptionId: verificationOptionId
        // };

        await new Promise(r => setTimeout(r, delaySendVerificationCode));

        return logAndPass(arguments, apiTestCase.successfulSendVerificationCode ? ok : notOk);
    }

    static async validate_verification_code(netid, code) {
        /* Real parameter usage */
        // let body = {
        //     netid: netid,
        //     token: code
        // };

        await new Promise(r => setTimeout(r, delayValidateVerificationCode));

        // 111111 -> always good code
        // 999999 -> always bad code
        // 999998 -> always bad code - null from server
        // anything else -> depends on succesfulValidateVerificationCode value

        if (code === "111111") return logAndPass(arguments, { ...ok, user: selectedUser, token: "222222" });
        if (code === "999999") return logAndPass(arguments, notOk);
        if (code === "999998") return logAndPass(arguments, null);

        return logAndPass(arguments, 
            apiTestCase.successfulValidateVerificationCode
            ? {...ok, user: selectedUser, token: "222222"}
            : notOk
        );
    }

    static async get_verification_options(netid) {
        /* Real parameter usage */
        // let response = await fetch(`/api/verification/options?netid=${netid}`, config);

        await new Promise(r => setTimeout(r, delayGetVerificationOptions));

        return logAndPass(arguments,
            apiTestCase.successfulGetVerificationOptions
            ? {...ok, result: selectedUser.verificationOptions} 
            : notOk
        );
    }

    static async get_version() {
        return logAndPass(arguments, 
            apiTestCase.successfulGetVersion
            ? {...ok, version: 'MockAPIService local version'}
            : notOk
        );
    }

    static async lookup(query) {
        /* Real parameter usage */
        // let response = await fetch(`api/user/lookup?query=${query}`, config);
         
        return logAndPass(arguments, apiTestCase.successfulLookup
            ? {...ok, truncated: false, users: [selectedUser]}
            : notOk
        );
    }   
}


function logAndPass(args, result) {
    // Example (new Error()).stack string running locally:
    /*
        logAndPass@http://localhost:3000/static/js/main.chunk.js:5635:16
        get_version@http://localhost:3000/static/js/main.chunk.js:5607:12
        fetchVersion@http://localhost:3000/static/js/main.chunk.js:4578:45
    */
    // const caller = (new Error()).stack.split("\n")[1].split("@")[0];

    // console.log("MockAPIService function: " + caller + "(" + JSON.stringify(args, null, 2) + ")");
    // console.log("Returning: " + JSON.stringify(result, null, 2));
    return result;
}